import styles from "./TenantWizard.module.scss";
import { FormProvider } from "react-hook-form";
import { SingleSectionPageLayout } from "../../../../common/components/common/SingleSectionPageLayout";
import { useTenantWizardPage } from "./hooks/useTenantWizardPage";
import { PageMode } from "../../../../common/types";
import { DefaultInputField } from "../../../../common/components/forms/inputs/InputField/DefaultInputField";
import { nameof } from "ts-simple-nameof";
import { ITenantWizardFormModel } from "./models/tenantWizardFormModel";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { HiddenField } from "../../../../common/components/forms/inputs/hiddenField/HiddenField";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { DefaultPhoneInputField } from "../../../../common/components/forms/inputs/phoneField/DefaultPhoneInputField";
import { classNames } from "primereact/utils";
import { TextEditor } from "../../../../common/components/forms/inputs/textEditor/TextEditor";

interface ITenantWizardProps {
  pageMode: PageMode;
}

export const TenantWizard = ({ pageMode }: ITenantWizardProps) => {
  const {
    form,
    actionButtonLabel,
    pageTitle,
    isEdit,
    isDesktopOrTablet,
    policyLastUpdatedOn,
    onSave,
  } = useTenantWizardPage(pageMode);

  const children = (
    <>
      <div className={styles.root_fields}>
        <HiddenField name={nameof<ITenantWizardFormModel>((x) => x.id)} />
        <DefaultInputField
          name={nameof<ITenantWizardFormModel>((x) => x.firstName)}
          label="Име"
          placeholder="Николай"
          required
        />

        <DefaultInputField
          name={nameof<ITenantWizardFormModel>((x) => x.lastName)}
          label="Фамилия"
          placeholder="Николаев"
          required
        />

        <DefaultPhoneInputField
          label="Телефонен номер"
          name={nameof<ITenantWizardFormModel>((x) => x.phoneNumber)}
        />

        <DefaultInputField
          name={nameof<ITenantWizardFormModel>((x) => x.email)}
          label="Имейл"
          placeholder="email@example.com"
          required
        />

        <TextEditor
          name={nameof<ITenantWizardFormModel>((x) => x.termsOfUse)}
          label={`Общи условия (Последно актуализирани на ${policyLastUpdatedOn})`}
        />
      </div>
      <div
        className={classNames(styles.root_buttons, {
          [styles.root_buttons_edit]: isEdit,
        })}
      >
        <DefaultButton
          className={styles.root_buttons_button}
          label={actionButtonLabel}
          type="submit"
        />

        <RenderWhen condition={!isEdit}>
          <div className={styles.root_buttons_info_text_wrapper}>
            <p
              className={styles.root_buttons_info_text}
              style={{ width: isDesktopOrTablet ? "300px" : "90%" }}
            >
              На следващата стъпка ще се добави и първия обект на клиента.
            </p>
          </div>
        </RenderWhen>
      </div>
    </>
  );

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSave)}>
        <SingleSectionPageLayout
          title={pageTitle}
          maxHeight={"90%"}
          children={children}
        />
      </form>
    </FormProvider>
  );
};
